import {personalizationAdapter} from "../adapters/personalization-adapter";

const PERSONALIZATION_URL = "/resources/personalization/v1/";
/* eslint-disable-next-line */
const GAP_SITES_REGEX = new RegExp(
  "^https?://[^/]*(gap.com|gap.eu|gapcanada.ca|bananarepublic.ca|oldnavy.ca|thegap.co.uk|gap.co.uk|bananarepublic.co.uk|bananarepublic.com|oldnavy.com|piperlime.com|athleta.com|local)",
  "i"
);
const HTTP_REGEX = new RegExp("^https?://", "i");
const getUnknownShopperId = () => {
  let unknownShopperId = "";

  try {
    unknownShopperId = document.cookie
      .split(";")
      .find((cookie) => cookie.includes("unknownShopperId"))
      .split("=")[1]
      .replace(/\|/g, "");
  } catch (err) {
    unknownShopperId = "initialize";
  }
  return unknownShopperId || "initialize";
};
const charToReplace = /[!'#()*]/g;
const getUrlParams = (searchQuery) =>
  searchQuery
    .substr(1)
    .split("&")
    .reduce((params, val) => {
      let [name, value] = (val || "").split("=");
      name = name.replace(charToReplace, "");
      value = (value || "").replace(charToReplace, "");
      if (name && value && !params[name]) {
        // eslint-disable-next-line no-param-reassign
        params[name] = encodeURIComponent(value);
      }
      return params;
    }, {});

const getParam = (key, val = "") =>
  val?.length ? `&${key}=${encodeURIComponent(val)}` : "";

// eslint-disable-next-line max-len
export const getReferrer = (ref = document.referrer) =>
  GAP_SITES_REGEX.test(ref) || !HTTP_REGEX.test(ref)
    ? ""
    : `&referrer=${escape(encodeURIComponent(ref))}`;

export const fetchPersonalization = ({
  marketAgnosticBrandCode,
  errorLogger,
}) => {
  // get querystrings
  const queryParams = getUrlParams(window.location.search);
  // get hash params
  const hashParams = getUrlParams(window.location.hash);
  const {DI: mdsId} = queryParams;
  let {tid, ap} = queryParams;
  // if tid is missing, check hashes to see if it exists
  if (!tid) {
    tid = hashParams?.tid;
  }
  // ap checks
  if (!ap) {
    ap = hashParams?.ap;
  }
  const originPath = global?.location ? global.location.pathname : "/";

  const unknownShopperId = getUnknownShopperId();

  const referrer = getReferrer();
  /*
  if this param exists it should be included to ensure PARTNER
  cookie reflects affiliate info for tracking
  */

  return fetch(
    `${PERSONALIZATION_URL}${unknownShopperId}?originPath=${originPath}${getParam(
      "tid",
      tid
    )}${getParam("ap", ap)}${getParam("mdsId", mdsId)}${referrer}`,
    {credentials: "include", referrer: "origin-when-cross-origin"}
  )
    .then((data) => data.json())
    .then(personalizationAdapter(marketAgnosticBrandCode))
    .catch((err) => {
      errorLogger(new Error(`[ERROR] error fetching personalization ${err}`));
    });
};
